//import contact from './contact';


const close = ( el ) => {
	let button = el.querySelector('.modal__nav__close');
	let overlay = el.querySelector('.modal__wrapper');
	button.onclick = () => {el.style.display = 'none'};
	overlay.onclick = (e) => {
		if (e.target === (overlay || button)) el.style.display = 'none';
	};
}

const contact = (title) => {
	let modal = document.getElementById('modal-contact');
	modal.style.display = 'block';
	document.getElementById('modal-contact-title').innerHTML = title;
	document.querySelector('#modal-contact-input-listing input').value = title;
	close(modal);
}


const shareButtons = (title, permalink) => {
	title = 'Allegiance Real Estate: ' + title;
	let buttons = {
		email: document.getElementById('share-email'),
		facebook: document.getElementById('share-facebook'),
		twitter: document.getElementById('share-twitter')
	}
	let hrefs = {
		email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(permalink)}`,
		facebook: `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(permalink)}`,
		twitter: `https://twitter.com/intent/tweet/?text=${encodeURIComponent(title)} ${encodeURIComponent(permalink)}&url=${encodeURIComponent(permalink)}"`
	}


	buttons.email.href = hrefs.email;
	buttons.twitter.href = hrefs.twitter;
	buttons.facebook.href = hrefs.facebook;
}

const share = (title, permalink) => {
	let modal = document.getElementById('modal-share');
	modal.style.display = 'block';
	document.getElementById('modal-share-title').innerHTML = title;
	shareButtons(title, permalink);
	close(modal);
}

const selected = (selector, cb) => {
	let els = document.querySelectorAll(selector);
	if ( els ) {
		els.forEach( (el) => {
			let title = el.getAttribute('data-title');
			let permalink = el.getAttribute('data-permalink');
			el.onclick = () => cb(title, permalink);
		});
	}
}

export default function () {
	selected('.button--share', share);
	selected('.button--contact', contact);
}
